import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { jqxTreeComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxtree';
import { jqxDropDownButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownbutton';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxBarGaugeComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxbargauge';
import { jqxButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxbuttons';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDataTableComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdatatable';
import { jqxComboBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcombobox';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxExpanderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxexpander';
import { jqxCheckBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcheckbox';
@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [jqxCheckBoxComponent,
    jqxExpanderComponent,
    jqxInputComponent,
    jqxComboBoxComponent,
    jqxDataTableComponent,
    jqxGridComponent,
    jqxButtonComponent,
    jqxBarGaugeComponent,
    jqxDropDownListComponent,
    jqxTreeComponent,
    jqxDropDownButtonComponent
  ],
  exports: [
    jqxCheckBoxComponent,
    jqxExpanderComponent,
    jqxInputComponent,
    jqxComboBoxComponent,
    jqxDataTableComponent,
    jqxGridComponent,
    jqxButtonComponent,
    jqxBarGaugeComponent,
    jqxDropDownListComponent,
    jqxTreeComponent,
    jqxDropDownButtonComponent,
  ]
})
export class jqxModule { }




// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/modules/jqx.module.ts